<template>
  <app-usage />
</template>
<script>
import AppUsage from '@/components/app-usage/AppUsage.vue'
export default {
  name: 'AppUsageView',
  components: {
    AppUsage
  }
}
</script>
<style lang="scss" scoped></style>
